module.exports = __webpack_public_path__ + "img/carousel-5.24b8282.png";